/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



(function() {
  // Add custom code below this line



   
document.addEventListener('DOMContentLoaded', function() {
    if (document.body.classList.contains('template-product')) {
        document.querySelectorAll('.product__block.product__accordions').forEach(function(el) {
            if (!el.querySelector('.product__accordion')) {
                el.style.paddingBottom = '0';
            }
        });
    }
});


var swiper = new Swiper(".swiper1", {
  slidesPerView: 4.5,
  spaceBetween: 30,
  loop: true,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2.5,
    },
    1024: {
      slidesPerView: 4.5,
    }
  }
});


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


(function(){
  let items = document.querySelectorAll("#find-your-match .column-item__text");
  let maxHeight = 0;

  // Reset any previous height
  items.forEach(item => item.style.minHeight = "");

  // Find the tallest
  items.forEach(item => {
    if (item.offsetHeight > maxHeight) {
      maxHeight = item.offsetHeight;
    }
  });

  // Apply to all
  items.forEach(item => {
    item.style.minHeight = maxHeight + "px";
  });


  
  
})();



window.addEventListener('load', () => {
  const carousel = document.querySelector('.carousel.carousel--mobile.carousel--inactive');
  const thumb = document.querySelector('.custom-scrollbar-thumb');
  const track = document.querySelector('.custom-scrollbar');

  if (!carousel || !thumb || !track) return;

  function updateThumb() {
    const scrollWidth = carousel.scrollWidth - carousel.clientWidth;
    const trackWidth = track.clientWidth;

    if (scrollWidth <= 0) {
      thumb.style.width = '100%';
      thumb.style.left = '0';
      return;
    }

    // Thumb width proportional to visible area
    const thumbWidth = (carousel.clientWidth / carousel.scrollWidth) * trackWidth;
    thumb.style.width = `${thumbWidth}px`;

    // Thumb position proportional to scroll
    const scrollPercent = carousel.scrollLeft / scrollWidth;
    const left = scrollPercent * (trackWidth - thumbWidth);
    thumb.style.left = `${left}px`;
  }

  // Initial update
  updateThumb();

  // Update thumb on scroll
  carousel.addEventListener('scroll', updateThumb);

  // Update thumb on resize
  window.addEventListener('resize', updateThumb);
});





function killEmailFocus() {
  document.querySelectorAll('[role="dialog"] input[type="email"]').forEach(input => {
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('focus', function() {
      input.blur(); 
    });
  });
}


// killEmailFocus();


// const observer = new MutationObserver(killEmailFocus);
// observer.observe(document.body, { childList: true, subtree: true });

